<template>
  <div class="w-full flex">
    <el-input
      class="flex-1"
      :placeholder="startPlaceholder"
      v-model="value[0]"
      @focus="$emit('startFocus', $event)"
      @blur="$emit('startBlur', $event)"
      @change="$emit('startChange', $event)"
      @input="$emit('startInput', $event)"
    />
    <span
      class="w-8 h-8 flex items-center justify-center text-theme-black-450 bg-theme-gray"
    >{{separator}}</span>
    <el-input
      class="flex-1"
      :placeholder="endPlaceholder"
      v-model="value[1]"
      @focus="$emit('endFocus', $event)"
      @blur="$emit('endBlur', $event)"
      @change="$emit('endChange', $event)"
      @input="$emit('endInput', $event)"
    />
  </div>
</template>

<script>
export default {
  name: 'InputFieldRange',
  props: {
    separator: {
      type: String,
      default: '~'
    },
    placeholders: {
      type: Array,
      default: () => ['', '']
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: Array,
      default: () => ['', '']
    }
  },
  computed: {
    startPlaceholder() {
      return ['', null, undefined].includes(this.placeholder) ? this.placeholders[0] : this.placeholder;
    },
    endPlaceholder() {
      return ['', null, undefined].includes(this.placeholder) ? this.placeholders[1] : this.placeholder;
    },
  }
}
</script>